import axios from 'axios';

export default async function checkBlocked(mobileNumber, logOutAction) {
  const status = await queryPhone(mobileNumber);
  if (status === 'blocked') {
    logOutAction();
  }
}

async function queryPhone(phoneNumber) {
  try {
    const { status, data } = await axios.get(`${api_config.bet_tracker_api}/phonenumber/${phoneNumber}`);
    return (status === 200) ? data.status : 'verified';
  } catch {
    return 'verified';
  }
}
